import $ from "jquery";

$(document).ready(function() {
	$('.share__btn_link').each(function() {
		$(this).click(function(e) {
			e.preventDefault();
			navigator.clipboard.writeText(location);
		});
	});
});
